export const environment = {
    production: true,
    apiBaseUrl: 'https://api.sanvictorio.com/v1',
    uploadPath: 'https://api.sanvictorio.com/',
    siteURL: 'https://sanvictorio.com/',
    SECRET_KEY: 'uTv@!ScTaS3#bE&o$',
googleMapKey: 'AIzaSyB-6OmdK_I0bxuSSvMK2JpwUBpUmgJQJu0'
};
